
export default class footerFAQ
{
    constructor() {
        this.el = '#frequentlyAskedQuestionSelector';

        if (!$(this.el).length) {
            return;
        }

        this.data = {
            questions: questions,
            faqPageURL: faqPageURL,
            selection: ''
        };

        this._initVue();
        this._initHeaderButton();
    }

    _initVue()
    {
        let vue = new Vue({
            el: this.el,
            data: this.data,
            methods: {
                submitForm()
                {
                    location.href = location.origin + this.faqPageURL + '#frequentQuestion' + this.selection;
                }
            }
        });
    }

    _initHeaderButton()
    {
        $('.ask-question-js').click(e => {
            e.preventDefault();
            $('html, body').animate(
                {
                    scrollTop: $(document).height()
                },
                "slow"
            );
        });
    }
}
